import * as React from 'react';

export default function useDimens() {
  const measuredEl = React.useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = React.useState<number | undefined>(undefined);
  const [height, setHeight] = React.useState<number | undefined>(undefined);

  function getDimens() {
    if (!measuredEl.current) {
      setWidth(undefined);
      setHeight(undefined);
      return;
    }
    const rect = measuredEl.current.getBoundingClientRect();
    setWidth(rect.width);
    setHeight(rect.height);
  }

  React.useEffect(() => {
    window.addEventListener('resize', getDimens);
    return () => {
      window.removeEventListener('resize', getDimens);
    };
  }, []);

  React.useEffect(getDimens, [measuredEl.current]);

  return { measuredEl, width, height };
}
